import { useMemo } from 'react';
import dayjs from 'dayjs';

export const useQualityMonitorDateRanges = () => {
  const today = dayjs().format('YYYY-MM-DD');

  return useMemo(() => {
    const startOfLastMonth = dayjs(today).subtract(1, 'month').startOf('month');

    return {
      startDateDayLimitViolations: startOfLastMonth,
      endDateDayLimitViolations: dayjs(today).add(6, 'month').endOf('month'),
      startDateAdditionalCompensations: startOfLastMonth,
      endDateAdditionalCompensations: dayjs(today).endOf('month')
    };
  }, [today]);
};
